import {
  AD_USERS,
  AdUser,
  LOGIN,
  LOGOUT,
  ME,
  type MEQuery,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';
import { connectionsApi } from './connections';

type LoginVariables = {
  username: string;
  password: string;
};

interface AdUsersResponse {
  adUsers: AdUser[];
}

export const authApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    logIn: build.mutation({
      query: (variables: LoginVariables) => ({
        document: LOGIN,
        variables,
      }),
    }),
    logOut: build.mutation({
      query: () => ({
        document: LOGOUT,
      }),
    }),
    getMe: build.query<MEQuery, void>({
      query: () => ({
        document: ME,
      }),
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(connectionsApi.endpoints.getAllConnections.initiate());
        } catch (error) {
          console.error(error);
        }
      },
      providesTags: ['Me', 'Auth'],
    }),
    getAdUsers: build.query({
      query: () => ({
        document: AD_USERS,
      }),
      transformResponse: (data: AdUsersResponse) => data.adUsers,
    }),
  }),
});

export const {
  useGetMeQuery,
  useLazyGetMeQuery,
  useLogInMutation,
  useLogOutMutation,
  useGetAdUsersQuery,
} = authApi;
